"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _KYCSettingsComponent = _interopRequireDefault(require("./KYCSettingsComponent"));
var _kycLevelsSelectors = require("../../redux/selectors/kycLevelsSelectors");
var _KYCTypeSwitchHelper = require("./KYCTypeSwitchHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _kycVerificationLevel = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state),
    kycConfig = _kycVerificationLevel.kycConfig;
  var LevelsComponent = ownProps.LevelsComponent || (0, _KYCTypeSwitchHelper.getKYCComponent)(kycConfig);
  return {
    LevelsComponent: LevelsComponent
  };
};
var KYCSettingsContainer = (0, _reactRedux.connect)(mapStateToProps)(_KYCSettingsComponent["default"]);
var _default = exports["default"] = KYCSettingsContainer;